<template>
  <div class="pageWrapper_home">
    <div class="top_header">
      <div class="container">
        <Header
          update_profile_txt=" Upload your pic"
          icon_txt="camera_alt"
          @uploadPicCallback="uploadPic()"
        />

        <div class="title_myprofile">
          <h1>{{$t('myProfile')}}</h1>
        </div>
      </div>
    </div>
    <div class="container_myProfile">
      <div class="middlePannel_myProfile">
        <div class="leftCol_myProfile">
          <div class="heading_leftcol">
            <h2>{{$t('fansRecord')}}</h2>
          </div>
          <div class="app_decline_column">
            <ul>
              <li @click="viewfanHistory()">
                <span class="history">
                  <!-- Fans History ({{this.$store.state.allvideos}}) -->

                  {{$t('fanHistory')}} ({{videos}})
                  <i class="material-icons">arrow_forward</i>
                </span>
              </li>
              <li @click="aceptedRequest()">
                <span class="decline">
                  {{$t('acceptedMessage')}} ({{profileDetails.accepted_request}})
                  <i
                    class="material-icons"
                  >arrow_forward</i>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="rightCol_myProfile">
          <div class="myProfile-section">
            <div class="heading_rightcol">
              <h2>
                {{$t('profile')}}
                <!-- <button class="save_details" @click="profileSaved()">Save</button> -->
              </h2>
            </div>
            <div class="profile_box">
              <div class="info-blk">
                <h2>{{$t('name')}}</h2>
                <p>{{profileDetails.name}}</p>
              </div>

              <div class="info-blk">
                <h2>{{$t('profession')}}</h2>
                <div
                  class="prof"
                  v-if="profileDetails.profession ? profileDetails.profession[0] : null"
                >
                  <p>{{profileDetails.profession[0]}}</p>
                </div>
              </div>

              <div class="info-blk">
                <h2>{{$t('bio')}}</h2>
                <p>{{profileDetails.bio}}</p>
              </div>

              <div class="info-blk">
                <h2>{{$t('setPrice')}}</h2>
                <p>{{profileDetails.min_fee}}</p>
              </div>
            </div>
          </div>
          <div class="video">
            <div class="txt_header">
              <h2>{{$t('videoProfile')}}</h2>
            </div>
            <div class="slider-img outcatg_gallery_box">
              <div class="prod_gallry_col" v-for="(video,id) in videoLink" :key="id">
                <div class="img_wrpr" @click="playVideo(video)">
                  <img src="../assets/images/video_overlay.png" class="videoImage" />
                </div>
              </div>
              <div v-for="gallery in profileDetails.wall">
                <div class="prod_gallry_col" v-if="gallery.type=='video'">
                  <div class="video_wrpr" @click="playVideo(gallery.link)">
                    <img :src="profileDetails.wall.thumbnail" v-if="profileDetails.wall.thumbnail" />
                    <img src="../assets/images/video_overlay.png" v-else class="videoImage" />
                  </div>
                </div>
              </div>
            </div>
            <div class="txt_header">
              <h2>{{$t('photoProfile')}}</h2>
            </div>

            <div class="slider-img outcatg_gallery_box">
              <div class="prod_gallry_col" v-for="(image,i) in imageBase64" :key="i">
                <div class="img_wrpr">
                  <img :src="image" />
                </div>
              </div>
              <div v-for="gallery in profileDetails.wall">
                <div class="prod_gallry_col" v-if="gallery.type=='image'">
                  <div class="img_wrpr">
                    <img :src="gallery.link" />
                  </div>
                </div>
              </div>
            </div>
            <VideoModel ref="vdoRefs" :v_link="v_link" v-if="isVideo" />
            <div class="play-block">
              <div class="right_container">
                <p>{{$t('newVideo')}}</p>
                <div class="click-btn">
                  <input
                    type="file"
                    id="videofileInput"
                    ref="myVdo"
                    accept="video/mp4, video/m4a, video/m4v, video/f4v, video/f4a, video/m4b, video/m4r, video/f4b, video/mov/video/*"
                    @change="uploadWallVideo"
                    class="custom-file-input"
                    style="display:none;"
                  />
                  <input
                    type="button"
                    :value="$t('uploadVideo')"
                    class="Makevideo_btn"
                    onclick="document.getElementById('videofileInput').click();"
                  />
                  <input
                    type="file"
                    id="imagefileInput"
                    ref="myFiles"
                    accept="image/*"
                    multiple
                    @change="uploadWallImage"
                    class="custom-file-input"
                    style="display:none;"
                  />
                  <input
                    type="button"
                    :value="$t('uploadImage')"
                    class="picupload_btn"
                    onclick="document.getElementById('imagefileInput').click();"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="social-profile">
            <div class="social-txt">
              <span>Social Profile</span>
            </div>
            <div class="insta-details">
              <span class="insta-icon">
                <img src="../assets/images/insta.jpeg" />
                <span class="insta-user">
                  <span class="insta-username">
                    <p>Instagram</p>
                    <p>@{{profileDetails.name}}</p>
                  </span>
                </span>
              </span>

              <button class="insta-btn" >View</button>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import VideoModel from "../components/VideoModel";
import { toaster } from "../utils/helper";
import { getBase64Url, b64toBlob } from "../utils/helper";
import { FILE_UPLOAD_URL } from "../utils/constant";
export default {
  name: "MyProfile",
  components: {
    Footer,
    Header,
    VideoModel
  },
  data() {
    return {
      celebrity_id: "",
      loading: false,
      profileDetails: "",
      imageBase64: [],
      videoBase64: [],
      wall: "",
      video: "",
      on_request: "",
      image: "",
      media_link: "",
      file: null,
      imageLink: [],
      videoLink: [],
      videoimages: [],
      v_link: null,
      isVideo: false,
      videos: 0
    };
  },
  methods: {
    playVideo(video) {
      this.v_link = video;
      this.isVideo = true;
      document.body.classList.add("videoBody");
    },
    aceptedRequest() {
      this.$router.push("/accepted-message");
    },
    viewfanHistory() {
      this.$router.push("/fan-history");
    },
    closeModal() {
      $(".img_wrpr").hide();
    },
    celebProfile() {
      this.loading = true;
      this.$store
        .dispatch({ type: "celebProfile" })
        .then(data => {
          this.profileDetails = data.data;
          this.loading = false;
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(
            this,
            this.$t("somethingWentwrong"),
            "top-center",
            2000
          );
        });
    },

    async uploadWallVideo(file) {
      this.loading = !this.loading;
      this.file = this.$refs.myVdo.files;
      let base64 = await getBase64Url(this.file[0]);
      let blob = b64toBlob(base64, this.file.type);
      const formData = new FormData();
      formData.append("image", blob);
      formData.append("isResizeRequired", true);
      await axios
        .post(FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          this.videoBase64.unshift(base64);
          const obj = {
            media_link:
              data.data.mediaVariantDTOs && data.data.mediaVariantDTOs[0].url,
            media_type: "wall",
            media_ext: "video"
          };
          this.loading = !this.loading;
          this.$store
            .dispatch({ type: "uploadVideo", payload: obj })
            .then(data => {
              this.videoLink.unshift(obj.media_link);
              toaster(this, this.$t("videoUploaded"), "bottom-center", 3000);
              document.getElementById("videofileInput").value = null;
            })
            .catch(err => {
              this.loading = !this.loading;
            });
        })
        .catch(err => {
          toaster(
            this,
            this.$t("somethingWentwrong"),
            "top-center",
            2000
          );
        });
    },
    async uploadWallImage(file) {
      this.file = this.$refs.myFiles.files;
      let base64 = await getBase64Url(this.file[0]);
      let blob = b64toBlob(base64, this.file.type);
      const formData = new FormData();
      formData.append("image", blob);
      formData.append("isResizeRequired", true);
      await axios
        .post(FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          this.imageBase64.unshift(base64);
          const obj = {
            media_link:
              data.data.mediaVariantDTOs && data.data.mediaVariantDTOs[0].url,
            media_type: "wall",
            media_ext: "image"
          };
          this.$store
            .dispatch({ type: "uploadVideo", payload: obj })
            .then(data => {
              this.imageLink.unshift(obj.media_link);
              toaster(this, this.$t("imageUploaded"), "bottom-center", 3000);
              document.getElementById("imagefileInput").value = null;
            })
            .catch(err => {
              this.loading = !this.loading;
            });
        })
        .catch(err => {
          toaster(
            this,
            this.$t("somethingWentwrong"),
            "top-center",
            2000
          );
        });
    },
    totalVideos() {
      this.$store
        .dispatch({ type: "totalUploadedVideos" })
        .then(data => {
          this.videos = data.data.total_videos;
        })
        .catch(err => {
          this.loading = !this.loading;
        });
    }
  },
  async mounted() {
    await this.$store
      .dispatch({ type: "celebProfile" })
      .then(data => {
        this.profileDetails = data.data;
      })
      .catch(err => {
        this.loading = !this.loading;
        toaster(
          this,
          this.$t("somethingWentwrong"),
          "top-center",
          2000
        );
      });

    this.totalVideos();
  }
};
</script>


